import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const orderId = params.get("order_id");
  const navigate = useNavigate();
  const [status, setStatus] = useState("polling");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("failed");
      return;
    }
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          setTimeout(() => navigate(`/orders/${orderId}`, { replace: true }), 1200);
          return;
        }
        if (data.payment_status === "failed" || data.payment_status === "expired") {
          setStatus("failed");
          return;
        }
      } catch {
        /* ignore */
      }
      attempts.current += 1;
      if (attempts.current >= 20) {
        setStatus("failed");
        return;
      }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, orderId, navigate]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center">
      {status === "polling" && (
        <>
          <div className="w-12 h-12 border-2 border-[var(--red)] border-t-transparent rounded-full animate-spin mb-6" />
          <p className="font-display text-2xl">Confirming your payment…</p>
          <p className="text-[var(--text-2)] text-sm mt-2">This usually takes a few seconds.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <div className="w-24 h-24 rounded-full bg-[var(--green)] border-2 border-[var(--text)] flex items-center justify-center mb-6" style={{ boxShadow: "5px 5px 0 0 var(--text)" }}>
            <CheckCircle size={44} weight="fill" className="text-white" />
          </div>
          <h1 className="font-display text-5xl">Baie dankie!</h1>
          <p className="text-[var(--text-2)] mt-2">Your order is confirmed. Taking you to live tracking…</p>
        </>
      )}
      {status === "failed" && (
        <>
          <div className="w-24 h-24 rounded-full bg-[var(--red)] border-2 border-[var(--text)] flex items-center justify-center mb-6" style={{ boxShadow: "5px 5px 0 0 var(--text)" }}>
            <XCircle size={44} weight="fill" className="text-white" />
          </div>
          <h1 className="font-display text-4xl">Payment could not be confirmed</h1>
          <p className="text-[var(--text-2)] mt-2">Please try again or contact support.</p>
          <button onClick={() => navigate("/")} className="btn-primary mt-6">Back to shop</button>
        </>
      )}
    </div>
  );
}
